import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/filter/box-open.svg'


const _withScopeId = n => (_pushScopeId("data-v-bc7057c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between align-items-center mb-7" }
const _hoisted_2 = { class: "d-flex flex-row gap-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"20px"},
  class: "m-0 fas fa-arrow-left"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-plus" }, null, -1))
const _hoisted_5 = { class: "col-12 d-flex flex-column p-0" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  style: {"background":"#203972","border-radius":"10px 10px 0px 0px"},
  class: "col-12 p-4 d-flex flex-row"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-white subtitulo col-10 d-flex justify-content-start" }, "DESCRIÇÃO"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-white subtitulo col-2 d-flex justify-content-end pe-10" }, "AÇÃO")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "d-flex w-100 flex-column bg-white",
  style: {"border-radius":"0 0 10px 10px"}
}
const _hoisted_8 = { class: "col-10 d-flex justify-content-start ps-6" }
const _hoisted_9 = { class: "col-2 d-flex justify-content-end pe-6" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 2,
  class: "card d-flex h-100 justify-content-center",
  id: "empty"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"color":"rgb(213 202 202)"} }, "Nenhuma bandeira para ser exibida.", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-5",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ModalCreateEditBandeira = _resolveComponent("ModalCreateEditBandeira")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode("Bandeiras")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_input, {
          placeholder: "Pesquise pelo nome da bandeira",
          clearable: "",
          modelValue: _ctx.inputFind,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputFind) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_router_link, {
          to: "/lojas",
          style: {"height":"fit-content","white-space":"nowrap"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, { text: "Voltar" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          text: "Adicionar",
          style: {"min-width":"fit-content"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('ModalCreateEditBandeira', 'create')))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("ul", _hoisted_5, [
      _hoisted_6,
      (_ctx.skeleton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_el_skeleton, {
              animated: "",
              rows: 16,
              class: "text-center p-5 d-block"
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.skeleton)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.bandeiras, (item, key) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "listaZebra col-12 d-flex flex-row align-items-center p-2",
              style: {"background":"#ffff"},
              key: key
            }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.descricao), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "btn btn-danger",
                  onClick: ($event: any) => (_ctx.clickedBandeira(item.codBandeira), _ctx.openModal('ModalCreateEditBandeira'))
                }, "Editar", 8, _hoisted_10)
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true),
      (!_ctx.bandeiras)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_component_Pagination, {
      ref: "pagination",
      key: _ctx.route.path,
      arr: _ctx.bandeiras,
      totalBanco: _ctx.totalBandeiras,
      onPageChanged: _ctx.handlePageChange,
      tipo: 'Bandeiras encontradas'
    }, null, 8, ["arr", "totalBanco", "onPageChanged"])),
    _createVNode(_component_ModalCreateEditBandeira, {
      bandeiraSelected: _ctx.bandeiraSelected,
      closeModal: _ctx.closeModal,
      getAllBandeiras: _ctx.getAllBandeiras
    }, null, 8, ["bandeiraSelected", "closeModal", "getAllBandeiras"])
  ]))
}